import { render, staticRenderFns } from "./UserCertificate.vue?vue&type=template&id=3d5b1514"
import script from "./UserCertificate.vue?vue&type=script&lang=js"
export * from "./UserCertificate.vue?vue&type=script&lang=js"
import style0 from "./UserCertificate.vue?vue&type=style&index=0&id=3d5b1514&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports